import { useMemo } from "react";
import { useGetStreams, useGetNotifications } from "security-app/hooks/useSigmaAPI";
export function useStreamOptions() {
  const { streams, streamCategories, loadingStreams } = useGetStreams();
  const streamOptions = useMemo(
    () => streams.filter((stream) => stream.is_editable).map((stream) => ({ label: stream.title, value: stream.id })),
    [streams]
  );
  const streamCategoryOptions = useMemo(
    () => streamCategories.map((category) => ({ label: category, value: category })),
    [streamCategories]
  );
  return { loadingStreams, streamOptions, streamCategoryOptions };
}
export function useNotificationOptions() {
  const { notifications, loadingNotifications } = useGetNotifications();
  const notificationOptions = useMemo(
    () => notifications.map((notification) => ({
      label: notification.title,
      value: notification.id
    })),
    [notifications]
  );
  return { loadingNotifications, notificationOptions };
}
